import logo from './logo.svg';
import './App.css';
import { FaCalendarAlt, FaCode, FaDownload, FaFacebookF, FaFileAlt, FaInstagram, FaLinkedinIn, FaMapMarkerAlt,  FaMobileAlt, FaTwitter } from 'react-icons/fa'; 
import { AiOutlineLink, AiOutlineUser, AiOutlineMenu, AiTwotoneContacts} from 'react-icons/ai'; 
import { FiMail } from 'react-icons/fi';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import About from './About';
import Resume from './Resume';
import Project from './Project';
import Contact from './Contact';
function App() {
  const handleDownload = () => {
    const pdfUrl = "Resume.pdf";
    window.open(pdfUrl, "_blank");
  };
  const handleLinkedInClick = () => {
    window.location.href = "https://www.linkedin.com/in/prince-maurya-810b83277";
  };
  const handleInstagramClick = () => {
    window.location.href = "https://www.instagram.com/princemaurya_10?igshid=MzNlNGNkZWQ4Mg%3D%3D";
  };
  const handleFacebookClick = () => {
    window.location.href = "https://www.facebook.com/profile.php?id=100073312225818";
  };
  const handleTwitterClick = () => {
    window.location.href = "https://twitter.com/PrinceM73729067";
  };

  const [showLinks, setShowLinks] = useState(false);
  const [showNavbarAndLogo, setShowNavbarAndLogo] = useState(true);

  const toggleLinks = () => {
    setShowLinks((prevShowLinks) => !prevShowLinks);
  };

  return (
    <>
    <div class="nav-bar-985">
      <h1 onClick={toggleLinks}>
        <AiOutlineMenu />
      </h1>
    {showLinks && (
      <div class="child-nav-bar-985">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/About">About</Link></li>
          <li><Link to="/Resume">Resume</Link></li>
          <li><Link to="/Project">Project</Link></li>
          <li><Link to="/Contact">Contact</Link></li>
        </ul>
      </div>
    )}
    </div>
    <div class="home1-container">
      <div class="parent-home1">
        <div class="home1-img">
          <img src="prince.jpg"></img>
          <div class="child-home1">
            <div class="child-home1-content">
              <h1>Prince Maurya</h1>
              <div class="sub-child-home1-content">
                <a herf="#">Web Developer</a>
              </div>
              <div class="sub-child-home1-logo">
                <h2 onClick={handleFacebookClick}><FaFacebookF /></h2>
                <h2 onClick={handleTwitterClick}><FaTwitter /></h2>
                <h2 onClick={handleInstagramClick}><FaInstagram /></h2>
                <a href="https://www.linkedin.com/in/prince-maurya-810b83277" target="_blank" rel="noopener noreferrer" onClick={handleLinkedInClick}><h2><FaLinkedinIn /></h2></a>
              </div>
              <div class="child-home1-contact-details">
                <div class="sub-child-home1-contact-details">
                  <div class="sub-child-home1-contact-icons">
                    <h2><FaMobileAlt /></h2>
                  </div>
                  <div class="sub-child-home1-contact-data">
                    <p style={{ color: 'grey' }}>Phone</p>
                    <p>+91 9987742369</p>
                  </div>
                </div>
                <hr></hr>
                <div class="sub-child-home1-contact-details">
                  <div class="sub-child-home1-contact-icons">
                    <h2><FiMail /></h2>
                  </div>
                  <div class="sub-child-home1-contact-data">
                    <p style={{ color: 'grey' }}>Email</p>
                    <p>prince@gmail.com</p>
                  </div>
                </div>
                <hr></hr>
                <div class="sub-child-home1-contact-details">
                  <div class="sub-child-home1-contact-icons">
                    <h2><FaMapMarkerAlt /></h2>
                  </div>
                  <div class="sub-child-home1-contact-data">
                    <p style={{ color: 'grey' }}>Location</p>
                    <p>India, Mumbai</p>
                  </div>
                </div>
                <hr></hr>
                <div class="sub-child-home1-contact-details">
                  <div class="sub-child-home1-contact-icons">
                    <h2><FaCalendarAlt /></h2>
                  </div>
                  <div class="sub-child-home1-contact-data">
                    <p style={{ color: 'grey' }}>Birthday</p>
                    <p>October 10, 2005</p>
                  </div>
                </div>
              </div>
            </div>
            <button onClick={handleDownload}><FaDownload /> Download CV</button>
          </div>
        </div>
      </div>
      <div class="child-main-home">
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/Resume" element={<Resume />} />
          <Route path="/Project" element={<Project />} />
          <Route path="/Contact" element={<Contact />} />
        </Routes>
      </div>
      <div class="child-home2">
        <div class="sub-child-home2">
          <Link to="/">
            <h2><AiOutlineUser /></h2>
          About</Link>
        </div>
        <div class="sub-child-home2">
          <Link to="/Resume">
            <h2><FaFileAlt /></h2>
          Resume</Link>
        </div>
        <div class="sub-child-home2">
          <Link to="/Project">
            <h2><FaCode /></h2>
          Project</Link>
        </div>
        <div class="sub-child-home2">
          <a href="https://linktr.ee/prince_maurya10" target="_blank">
            <h2><AiOutlineLink /></h2>
          LinkTree
          </a>
        </div>
        <div class="sub-child-home2">
          <Link to="/Contact">
            <h2><AiTwotoneContacts /></h2>
          Contact</Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default App;
